import apiClient from './apiClient';

export class CatCodesService {

  /**
   * 
   * @param {
   *      searchText: string,
   *   sortOrderField: string,
   *    sortDirection: string,
   *     itemsPerPage: number,
   *      itemsToSkip: number
   * } search
   * @returns {Promise<{
   *   items: [
   *     {
   *                        id: number,
   *             catCodeString: string,
   *               catCodeDesc: string,
   *               partGroupID: number,
   *            wordsToInclude: string,
   *            wordsToExclude: string,
   *          daysBetweenScans: number,
   *             refinedMinQty: number,
   *                    qtyCap: number,
   *              minQtyToScan: number,
   *                  clientID: number,
   *       marketplaceSettings: [
   *         {
   *            marketplaceName: string,
   *           daysBetweenScans: number,
   *         }
   *       ]
   *     }
   *   ],
   *   totalItemCount: number
   * }>}  
   */
  async getCatCodes(search) {
    const response = await apiClient.getWithCache("api/catCodes/", {
      params: search
    });
    return response.data;
  }
  
  async getCatCode(id) {
    const response = await apiClient.getWithCache("api/catCodes/" + id);
    return response.data;
  }

  async getCatCodeByString(catCodeString) {
    console.log("getCatCodeByString: " + catCodeString);
    const response = await apiClient.getWithCache("api/catCodes/ByString/" + catCodeString);
    console.log("getCatCodeByString data: " + response.data);
    return response.data;
  }

  async getVendorListItems(catCodeString) {
    const response = await apiClient.getWithCache("api/catCodes/ByString/" + encodeURIComponent(catCodeString) + "/VendorListItems");
    return response.data;
  }

  async saveCatCode(catCode) {
    const response = await apiClient.post("api/catCodes", catCode);
    apiClient.clearCache('api/catCodes');
    return response.data;
  }

  async deleteCatCode(id) {
    const response = await apiClient.delete("api/catCodes/" + id);
    apiClient.clearCache('api/catCodes');
    return response.data;
  }
}
